module.exports = __webpack_public_path__ + "static/media/izlozba (6).59d6b69c.jpg";